<template>
  <div class="page" v-loading="listLoading">
    <el-form @submit.native.prevent label-width="100px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="营客通:">
            <el-select :remote-method="getDistributorList" filterable remote clearable v-model="searchData.SupIds"
              placeholder="请选择">
              <el-option v-for="item in supplierList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品Id:">
            <el-input v-model="searchData.SpuIds" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品名称:">
            <el-input v-model="searchData.ProName" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品型号:">
            <el-input v-model="searchData.ModelCode" placeholder="请输入型号" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="状态：">
            <el-select v-model="searchData.IsShelves" placeholder="请选择">
              <el-option label="全部" :value="null" />
              <el-option label="上架" :value="true" />
              <el-option label="下架" :value="false" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item>
            <div class="flex">
              <el-button type="primary" @click="searchFun">查询</el-button>
              <el-button @click="resetFun">重置</el-button>
              <toolbar class="mgl10" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!--列表-->
    <el-table :data="tableList" highlight-current-row element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
      @selection-change="selectCurrentRow" style="width: 100%" border>
      <el-table-column type="selection" width="50" fixed align="center"></el-table-column>
      <el-table-column prop="spuId" label="外部商品Id" width="100" align="center"></el-table-column>
      <el-table-column prop="proName" label="商品名称" align="center" min-width="300"></el-table-column>
      <el-table-column prop="modelCode" label="型号" align="center" min-width="300"></el-table-column>
      <el-table-column prop="typeName" label="商品类型" width="120" align="center"></el-table-column>
      <el-table-column prop="brandName" label="商品品牌" width="120" align="center"></el-table-column>
      <el-table-column label="状态" prop="isShelves" width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.isShelves ? "上架" : "下架" }}
        </template>
      </el-table-column>
      <el-table-column width="100" label="操作" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"
            @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]">
    </el-pagination>
  </div>
</template>

<script>
import {
  ErpUnSentProductList,
  ErpUnSentProductImport,
  GetAllReseller
} from "../../../api/api";
import { getButtonList } from "../../../promissionRouter";
import Toolbar from "../../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      searchData: {
        SupIds: null,
        SpuIds: null,
        ProName: null,
        ModelCode: null,
        IsShelves: null,
        pageIndex: 1, //页码
        pageSize: 10, //页长
      },
      supplierList: [],
      total: 0,
      listLoading: false,
      currentRow: [],
      buttonList_toolBar: [],
      buttonList_table: [],
      tableList: [],
    };
  },
  created() {
    this.getSpusOnSale();
    this.getDistributorList();
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      this.buttonList_toolBar = toolBarButtonList;
      const tableButtonList = buttonList.filter((item) => {
        return item.buttonShow === 20;
      });
      this.buttonList_table = tableButtonList;
    }
  },
  methods: {
    async getDistributorList(Name) {
      let res = await GetAllReseller({ PageIndex: 1, PageSize: 50, Name });
      if (res.data.success) {
        this.supplierList = res.data.result.items
      } else {
        this.$message.error(res.data.error.message)
      }
    },
    searchFun() {
      this.searchData.pageIndex = 1;
      this.getSpusOnSale();
    },
    resetFun() {
      this.searchData = {
        SupIds: null,
        SpuIds: null,
        ProName: null,
        ModelCode: null,
        IsShelves: null,
        pageIndex: 1, //页码
        pageSize: 10, //页长
      }
      this.getSpusOnSale();
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    handleCurrentChange(val) {
      this.searchData.pageIndex = val;
      this.getSpusOnSale();
    },
    handleSizeChange(e) {
      this.searchData.pageSize = e;
      this.getSpusOnSale();
    },
    //获取商品列表
    getSpusOnSale() {
      this.listLoading = true;
      ErpUnSentProductList(this.searchData).then((res) => {
        if (res.data.success) {
          this.total = res.data.result.data.dataCount;
          this.tableList = res.data.result.data.data || [];
        } else {
          this.$message.error(res.data.result)
        }
        setTimeout(() => {
          this.listLoading = false;
        }, 500)
      });
    },
    handleGet(item, index, row) {
      this.ErpUnSentProductImport([row.spuId])
    },
    handleBatchGet() {
      if (this.currentRow.length) {
        this.ErpUnSentProductImport(this.currentRow.map(item => { return item.spuId }))
      } else {
        this.$message({
          message: '请选择',
          type: 'warning'
        });
      }
    },
    ErpUnSentProductImport(spuIds) {
      this.$confirm('是否确认获取?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.listLoading = true;
        ErpUnSentProductImport({
          spuIds
        }).then((res) => {
          this.listLoading = false;
          if (res.data.success) {
            if (res.data.result) {
              this.$message.success(res.data.result)
            }
            this.getSpusOnSale()
          } else {
            this.$message.error(res.data.result)
          }
        });
      }).catch(() => { });
    }
  },
};
</script>

<style scoped></style>
